export const CURRENCY_CONSTANTS = {
    UST: 'UST',
};
